<template>
  <div class="page-bg page">
    <SubHeader title="" :isBack="true" :isBg="false"></SubHeader>
    <div class="main">
      <div class="page-content">
        <div class="details-img">
          <div class="img-wrap">
            <div class="img">
              
              <div class="swiper-banner-container" ref="swiper-banner-container">
                <div class="swiper-wrapper">
                  <div class="swiper-slide">

                    <div class="animate" v-if="details.image_url.length > 1" >
                      <img :src="item" v-for="(item,index) in details.image_url" :key="index" alt="" />
                    </div>
                    <div class="pic" v-else><img :src="details.image_url" alt="" /></div>

                  </div>
                  <div class="swiper-slide" v-if="details.videos">
                    <div class="video">
                      <video 
                        muted
                        loop
                        preload="auto" 
                        autoplay="autoplay" 
                        x5-playsinline="true" 
                        playsinline="true" 
                        webkit-playsinline="true" 
                        x-webkit-airplay="true" 
                        x5-video-player-type="h5" 
                        x5-video-player-fullscreen="true" 
                        x5-video-orientation="portraint"
                      ><source :src="details.videos" type="video/mp4"></video>
                    </div>
                  </div>

                </div>
                <div class="swiper-pagination" ref="swiper-banner-pagination"></div>
              </div>
              
              <!-- <img :src="details.image_url" alt="" /> -->
            </div>
            <div class="info">
              <div class="title">{{ details.title }}</div>
            </div>
          </div>
        </div>      
        <div class="details-box">
          <div class="details-info">
            <div class="info-ftitle">收藏者</div>
            <div class="info-code">
              <div class="info-box">
                <div class="text">
                  <span ref="info_title">{{ userInfo.nickname }}</span>
                </div>
                <div class="icon">
                  <div class="x" ref="star"></div>
                  <div
                    class="x"
                    v-for="(item, index) in star_num"
                    :key="index"
                  ></div>
                </div>
              </div>
            </div>

            <div class="liner"></div>
            <div class="info-ftitle">藏品哈希值</div>
            <div class="info-hax">{{ details.artHax }}</div>
            <div class="liner"></div>
            <div class="info-ftitle">创作者</div>
            <div class="info-text">{{ details.author }}</div>
            <div class="liner"></div>
            <div class="info-ftitle">获得时间</div>
            <div class="info-text">{{ details.getToDate }}</div>
          </div>
        </div>

        <GeneratePoster
          :shareInfo="shareInfo"
          ref="GeneratePoster"
        ></GeneratePoster>

        <div style="height: 1.32rem"></div>
        <div class="details-nav">
          <div class="item" @click="shareBtn">
            <div class="icon">
              <img src="../../../assets/images/user/treasure/ic-1.png" alt="" />
            </div>
            <div class="text">炫耀</div>
          </div>
          <div class="item">

            <a :href="'https://render.antfin.com/p/s/miniapp-web/?type=trans&from=aliyun&bizid=fc12ae4da9e740a0ab0569fab61a8151&hash='+details.getToHash" target="_blank" rel="noopener noreferrer">
              <div class="icon">
                <img src="../../../assets/images/user/treasure/ic-2.png" alt="" />
              </div>
              <div class="text">证书</div>
            </a>
            
          </div>
          <div class="item" @click="$router.push('/user/treasure/sethead?img='+details.avatarimg)">
            <div class="icon">
              <img src="../../../assets/images/user/treasure/ic-3.png" alt="" />
            </div>
            <div class="text">使用</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

import Vue from "vue";
import Swiper from "../../../assets/js/libs/swiper.min";

import SubHeader from "../../../components/sub_header";
import GeneratePoster from "../../../components/generate_poster";
import { mapActions, mapState } from "vuex";
import { Toast } from "vant";


export default {
  name: "user-treasure-details",
  data() {
    return {

      gid: this.$route.query.id ? this.$route.query.id : "",
      details: {
        title: "",
        image_url: "",
        artId: "",
        artHax: "",
        auther: "",
        getToDate:"",
        shareText: "",
        avatarimg:"",
        getToHash:"",
        userowner:"",

      },
      infoTitle: "",
      star_num: 6,

      isShare: false,
      shareInfo: {
        title: "",
        author: "",
        image_url: "",
        shareText: "",
      },
    };
  },
  components: {
    GeneratePoster,
    SubHeader
  },

  watch: {
    infoTitle(newVal, oldVal) {
      // console.log(newVal);
      let vm = this;
      vm.$nextTick(async () => {
        // console.log(vm.$refs.info_title.offsetWidth);
        // console.log(vm.$refs.star.offsetWidth);

        let starWidth = vm.$refs.star.offsetWidth;
        let infoTitleWidth = vm.$refs.info_title.offsetWidth;

        starWidth = starWidth * 3;
        this.star_num = Math.ceil(infoTitleWidth / starWidth) - 1;

        if(this.star_num < 8 ){
          this.star_num = 8;
        }

        console.log(this.star_num);


      });
    },
  },

  created() {

    document.title = this.$route.meta.title;
    this.headerTitle = this.$route.meta.title;


    let vm = this;
    if (!parseInt(this.gid)) {
      Toast.fail("参数错误");
      setTimeout(() => {
        Toast.clear();
        this.$router.go(-1);
      }, 600);
      return false;
    }

    if(vm.goodList.length > 0){      
      let details = vm.goodList.filter((item) => {
        return Number(item.id) === Number(this.gid);
      });
      vm.getDetails(details[0]);
    } else {
      vm.getGoodsList();
    }
    

  },
  methods: {

    ...mapActions({
      getGoodsOrderList: "user/getGoodsOrderList",
    }),

    
    getGoodsList(){
      let that = this;
      let goodsTimeSort = this.goodsTimeSort;
      this.getGoodsOrderList({
        goodsTimeSort:goodsTimeSort,
        success: (res) => {
          console.log(res)
          if (res.status === 1) {

            let orderArr = res.data.order;
            if(orderArr.length > 0){
              let details = orderArr.filter((item) => {
                return Number(item.id) === Number(this.gid);
              });
              that.getDetails(details[0]);
            }
            
          } else {
            Toast(res.message);
          }

        },
      });
    },

    getDetails(info){

      let that = this;
      that.infoTitle = info.products[0].nftArt.artName;
      that.details.title = info.products[0].nftArt.artName;
      that.details.artId = info.products[0].nftArt.artId;
      that.details.author = info.products[0].nftArt.auther;
      that.details.image_url = info.products[0].area.imageurl;
      
      that.details.avatarimg = info.products[0].area.avatarimg;

      that.details.artHax = info.products[0].nftArt.artHax;
      that.details.getToDate = info.products[0].nftArt.getToDate;
      that.details.getToHash = info.products[0].nftArt.getToHash;
      that.details.userowner = info.products[0].nftArt.userowner;

      

      that.details.videos = info.products[0].videos;

      // console.log(that.details);

      that.isShow = true;
      that.$nextTick(async () => {
        that.shareInfo.title = that.details.title;
        that.shareInfo.artId = that.details.artId;

        that.shareInfo.author = that.details.author;
        that.shareInfo.image_url = that.details.image_url[0];
        that.shareInfo.artHax = that.details.artHax;
        that.shareInfo.getToDate = that.details.getToDate;
        that.shareInfo.getToHash = that.details.getToHash;
        that.shareInfo.userowner = that.userInfo.nickname;

        // that.shareInfo.status = that.details.status;
        that.shareInfo.shareText =  that.community[3].name;
        let url = 'http://www.yoysky.art/';
        that.$refs.GeneratePoster.createQrcode(url); // 方法2:直接调用

        if(that.details.videos){
          that.swiperBannerFun();
        }
        
      });

      

    },
    swiperBannerFun(){
      let that = this;    
      that.swiperBanner = new Swiper(this.$refs["swiper-banner-container"], {
        init: true,
        slidesPerView: 1,
        paginationClickable: true,
        spaceBetween: 30,
        initialSlide: 0,
        loop: false, // 循环模式选项
				observer: true, //修改swiper自己或子元素时，自动初始化swiper
				observeParents: true,//修改swiper父元素时，自动初始化swiper
				observeSlideChildren: true,
        resizeObserver: true,
      });
      that.$nextTick(() => {
				that.swiperBanner.update();
			})

    },


    shareBtn() {
      this.$refs.GeneratePoster.createPoster(); // 方法2:直接调用
    },


  },
  computed: {
    ...mapState({
      isLogin: (state) => state.user.isLogin,
      userInfo: (state) => state.user.userInfo,
      goodList:(state)=>state.user.goodList,

      community: (state) => state.index.community,

    }),

  },

  mounted() {},

  activated() {
    document.title = this.$route.meta.title;
    this.headerTitle = this.$route.meta.title;
  },
};
</script>

<style lang="scss" scoped>

@import "../../../assets/css/common/swiper.min.css";

@keyframes xz1 {
  0%{
    transform: rotateY(0deg);
  }
  50%{
    transform: rotateY(180deg);
  }
  100%{
    transform: rotateY(0deg);
  }
}

@keyframes xz2 {
  0%{
    transform: rotateY(-180deg);
  }  
  50%{
    transform: rotateY(0);
  }   
  100%{
    transform: rotateY(-180deg);
  }
}

.swiper-banner-container {
  overflow: hidden;
  position: relative;
  img {
    width: 100%;
  }
}
.page {
  width: 100%;
  background-size: cover;
  box-sizing: border-box;
  height: 100vh;
}

.header-title {
  position: absolute;
}

.main {
  width: 100%;
  box-sizing: border-box;
  height: 100vh;
  position: relative;
}
.page-content {
  position: relative;
  overflow-y: auto;
  height: 100%;
}
.details-img {
  width: 100%;
  position: relative;
  box-sizing: border-box;
  // padding: 0 0.6rem;

  .img-wrap {
    width: 100%;
    height: 8.34rem;
    box-sizing: border-box;
    background: url("../../../assets/images/user/treasure/img-b.png") no-repeat
      bottom center;
    background-size: 84% auto;
    padding-top: 0.7rem;
    .img {
      text-align: center;
      width: 100%;
      height: 5.07rem;
      img {
        // height: 100%;
        width: auto;
        max-width: 100%;
      }
      
      
      .pic {
        position: relative;
        height: 5.07rem;        
        width: 80%;
        margin: 0 auto ;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .animate {
        position: relative;
        height: 5.07rem;
        width: 80%;
        margin: 0 auto;
        text-align: center;
        img {          
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          backface-visibility: hidden;
          transition: all 1s;
          &:nth-of-type(2){
            transform: rotateY(-180deg);
          }
        }              
        img:nth-of-type(1){
          animation: xz1 12s ease-in-out 1s infinite;
        }        
        img:nth-of-type(2){
          animation: xz2 12s ease-in-out 1s infinite;
        }
      }
      .video {
        width: 80%;
        margin: 0 auto;
        height: 5.07rem;
        display: flex;
        align-items: center;
        justify-items: center;
        video {
          width: 100%;
          height: 100%;
        }
      }
    }
    .info {
      margin-top: 0.7rem;
      height: 1.37rem;
      text-align: center;
      box-sizing: border-box;
      padding-top: 0.25rem;
      .title {
        font-size: 0.48rem;
        color: #ffffff;
        line-height: 1;
        font-weight: bold;
        overflow: hidden;
        // width: 40%;
        margin: 0 auto;
        white-space: nowrap;
        // text-overflow: ellipsis;
      }
    }
  }
}

.details-box {
  padding: 0 0.16rem 1rem;
  overflow: hidden;

  .details-info {
    background: url("../../../assets/images/user/treasure/bg-1.jpg") left top
      #fafafa;
    background-size: 0.2rem 0.37rem;
    border-radius: 0.2rem;
    overflow: hidden;
    box-shadow: 0 0.03rem 0.087rem 0.01rem rgba(0, 0, 0, 0.3);
    padding: 0.43rem 0.43rem 0.7rem;
    box-sizing: border-box;

    .info-ftitle {
      font-size: 0.27rem;
      color: #5e5e5e;
      text-align: center;
    }
    .info-code {
      width: 4.28rem;
      position: relative;
      margin: 0.2rem auto 0;
      padding: 0.18rem 0 0.12rem;
      box-sizing: border-box;

      &::before,
      &::after {
        content: "";
        position: absolute;
        left: 0;
        width: 100%;
        height: 0.2rem;
        background: url("../../../assets/images/user/treasure/code-border.png")
          no-repeat;
        background-size: 100% auto;
      }

      &::before {
        top: 0;
        background-position: left top;
      }
      &::after {
        bottom: 0;
        background-position: left bottom;
      }
      .info-box {
        background: url("../../../assets/images/user/treasure/code-border-1.png")
          repeat-y;
        background-size: 100% auto;
        padding: 0 0.1rem;
        .text {
          text-align: center;
          font-size: 0.34rem;
          color: #252525;
          line-height: 1.2;
          word-break:break-all;

          span {
            display: inline-block;
          }
        }
        .icon {
          display: flex;
          align-items: center;
          width: 3.4rem;
          justify-content: space-between;
          margin: 0 auto;
          margin-top: 0.05rem;
          .x {
            width: 0.19rem;
            height: 0.18rem;
            background: url("../../../assets/images/user/treasure/x.png")
              no-repeat;
            background-size: 100%;
          }
        }
      }
    }

    .liner {
      border-top: 1px solid #e9e9e9;
      margin: 0.3rem 0 0.18rem;
    }

    .info-hax {
      background-image: linear-gradient(left, #faf4e8, #edcf9b);
      color: #5e5e5e;
      font-size: 0.28rem;
      border-radius: 0.1rem;
      width: 97%;
      text-align: center;
      margin: 0 auto;
      padding: 0.25rem;
      box-sizing: border-box;
      word-break: break-all;
      margin-top: 0.2rem;
    }
    .info-text {
      text-align: center;
      font-size: 0.36rem;
      color: #252525;
      margin-top: 0.15rem;
    }
  }
}

.details-nav {
  position: fixed;
  left: 0;
  width: 100%;
  bottom: 0;
  z-index: 9;
  background-image: linear-gradient(left, #363435, #201e1f);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.32rem 0;
  .item {
    flex: 1;
    height: 0.68rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #fff;
    &:last-child {
      border-right: 0;
    }
    .icon {
      font-size: 0;
      margin-right: 0.2rem;
      img {
        height: 0.46rem;
      }
    }
    a {
      display: flex;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .text {
      font-size: 0.27rem;
      color: #ffffff;
    }
    &:active {
      .icon,.text {
        opacity: .7;
      }
    }
  }
}
</style>

